/* global module */

'use strict';

const SELECTORS = {
    body: 'body',
    mainContent: '#maincontent',
    modal: '.js-overwrite-fit-modal',
    fitForm: '.js-overwrite-fit-form',
    submitBtn: '.js-overwrite-fit-submit',
    clearBtn: '.js-clear-session-btn'
};

/**
 * Initialize fir finder.
 * @returns {void}
 */
const init = () => {
    let overwriteModal = $(SELECTORS.modal);
    if (overwriteModal.length > 0) {
        overwriteModal.modal('show');
    }

    $(SELECTORS.body).on('click', SELECTORS.submitBtn, handleSubmitBtn);
    $(SELECTORS.body).on('click', SELECTORS.clearBtn, handleClearBtn);
};

const handleSubmitBtn = () => {
    let $fitForm = $(SELECTORS.fitForm);

    $.ajax({
        url: $fitForm.attr('action'),
        method: 'POST',
        success: function (response) {
            if (response.message) {
                let alert = $('<div/>')
                    .addClass('alert alert-success text-center container mt-5')
                    .text(response.message)
                    .hide()
                    .fadeIn();
                $(SELECTORS.mainContent).prepend(alert);

                setTimeout(function () {
                    alert.fadeOut().remove();
                }, 3000)
            }
        }
    });
}

const handleClearBtn = () => {
    let $fitForm = $(SELECTORS.fitForm);

    $.ajax({
        url: $fitForm.data('clear-fit-url'),
        method: 'POST'
    });
}


module.exports = {
    init
};